import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useLocale } from '../../i18n/locale-context.js';
export function ExportExecutingStep(props) {
    const { t } = useLocale();
    const includesErasure = props.erasureComposition !== 'none';
    const status = includesErasure
        ? t('export.executing.status_with_erasure')
        : t('export.executing.status_without_erasure');
    return (_jsxs("section", { "aria-labelledby": "executing-heading", "aria-busy": "true", children: [_jsx("h3", { id: "executing-heading", children: t('export.executing.heading') }), _jsx("p", { role: "status", children: status })] }));
}
//# sourceMappingURL=executing-step.js.map